import { render, staticRenderFns } from "./TrackWidget.vue?vue&type=template&id=463a485b&"
import script from "./TrackWidget.vue?vue&type=script&lang=js&"
export * from "./TrackWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports